import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const createMuiStyles = <T>(styles: { [K in keyof T]: SystemStyleObject<Theme> }) => styles;
